import Vue from 'vue';
import App from './App.vue';
//引入自定义路由
import VueRouter from 'vue-router';
import router from './router';
// 引入element-ui全部css
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
import Magnifier from "vue-magnifier";
import less from 'less';
Vue.use(less)

// eslint-disable-next-line vue/multi-word-component-names
Vue.component("magnifier", Magnifier);

// 关闭Vue的生产提示
Vue.config.productionTip = false
// 使用element
Vue.use(ElementUI);
//使用插件
Vue.use(VueRouter)
document.title = '3000套 "Java"/"小程序" 项目合集';
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
